/**
 * Fandom Brands Module
 * Handles hover interactions for brand cards with video/image playback
 * Optimized for performance with reduced DOM queries and efficient event handling
 */

// Wait for jQuery to be available
(function() {
    function initFandomBrands() {
      if (typeof jQuery === 'undefined') {
        setTimeout(initFandomBrands, 50);
        return;
      }

      const $ = jQuery;

  /* ===== Fandom Brands – hover play ===== */
  $(function () {
    const CAN_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // Cache all brand cards and media elements for better performance
    const $brandCards = $('.fandom-brands-blocks-inner .brand-image-box');
    const $iframes = $('iframe.brand-card__media');

    // Batch iframe API enablement to reduce DOM manipulations
    const iframeUpdates = [];
    $iframes.each(function () {
      const $el = $(this);
      let src = $el.attr('src') || '';
      let needsUpdate = false;

      if (/youtube\.com|youtu\.be/.test(src) && !/enablejsapi=1/.test(src)) {
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'enablejsapi=1&playsinline=1&mute=1';
        needsUpdate = true;
      }
      if (/vimeo\.com/.test(src) && !/api=1/.test(src)) {
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'api=1&muted=1&background=1';
        needsUpdate = true;
      }

      if (needsUpdate) {
        iframeUpdates.push({ element: this, src: src });
      }

      $el.attr('allow', 'autoplay; encrypted-media; picture-in-picture');
    });

    // Batch update iframe sources to reduce reflows
    iframeUpdates.forEach(update => {
      update.element.src = update.src;
    });

    // Log Fandom Brands initialization once
    if (window.CarouselCore) {
      window.CarouselCore.logCarouselInit('Fandom Brands');
    }

    // Pre-cache all media elements to avoid repeated DOM queries
    const cardData = [];
    $brandCards.each(function () {
      const $card = $(this);
      const video = $card.find('video.brand-card__media').get(0);
      const iframe = $card.find('iframe.brand-card__media').get(0);

      cardData.push({
        element: this,
        $card: $card,
        video: video,
        iframe: iframe
      });
    });

    // Optimized media control functions
    const playMedia = function (cardData) {
      if (!CAN_HOVER) return;
      const { video, iframe, $card } = cardData;
      if (!video && !iframe) return;

      $card.addClass('is-playing');

      if (video) {
        video.muted = true;
        video.play().catch(() => {});
      } else if (iframe) {
        const src = iframe.src || '';
        if (/youtube\.com|youtu\.be/.test(src)) {
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
        } else if (/vimeo\.com/.test(src)) {
          iframe.contentWindow?.postMessage('{"method":"play"}', '*');
        }
      }
    };

    const pauseResetMedia = function (cardData) {
      const { video, iframe, $card } = cardData;
      $card.removeClass('is-playing');

      if (video) {
        video.pause();
        video.currentTime = 0;
      } else if (iframe) {
        const src = iframe.src || '';
        if (/youtube\.com|youtu\.be/.test(src)) {
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'seekTo', args: [0, true] }), '*');
        } else if (/vimeo\.com/.test(src)) {
          iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
          iframe.contentWindow?.postMessage('{"method":"setCurrentTime","value":0}', '*');
        }
      }
    };

    // Create a map for quick card lookup
    const cardMap = new Map();
    cardData.forEach(data => {
      cardMap.set(data.element, data);
    });

    // Use event delegation for better performance
    if (CAN_HOVER) {
      $(document).on('mouseenter', '.fandom-brands-blocks-inner .brand-image-box', function() {
        const cardData = cardMap.get(this);
        if (cardData) playMedia(cardData);
      });

      $(document).on('mouseleave', '.fandom-brands-blocks-inner .brand-image-box', function() {
        const cardData = cardMap.get(this);
        if (cardData) pauseResetMedia(cardData);
      });

      $(document).on('focusin', '.fandom-brands-blocks-inner .brand-image-box', function() {
        const cardData = cardMap.get(this);
        if (cardData) playMedia(cardData);
      });

      $(document).on('focusout', '.fandom-brands-blocks-inner .brand-image-box', function() {
        const cardData = cardMap.get(this);
        if (cardData) pauseResetMedia(cardData);
      });
    } else {
      // On touch devices, ensure all cards are paused
      cardData.forEach(data => pauseResetMedia(data));
    }

    // Shared Intersection Observer for all cards (much more efficient)
    window.sharedObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          const cardData = cardMap.get(entry.target);
          if (cardData) pauseResetMedia(cardData);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px' // Add margin to reduce observer conflicts
    });

    // Observe all cards with single observer - only if not already observed
    cardData.forEach(data => {
      if (!data.element.dataset.observed) {
        data.element.dataset.observed = 'true';
        window.sharedObserver.observe(data.element);
      }
    });
  });
  /* ===== Fandom Brands – hover play ===== */

    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFandomBrands);
    } else {
      initFandomBrands();
    }
  })();

  // Export for use in other modules
  window.FandomBrands = {
    // Expose key functions if needed by other modules
    cleanup() {
      // Disconnect shared observer to prevent memory leaks
      if (window.sharedObserver) {
        window.sharedObserver.disconnect();
        window.sharedObserver = null;
      }
    }
  };
